export const parentDocumentCanCreateTypePatcher = (data) => {
    return {
        __typename: 'ParentDocumentCanCreate',
        ...data,
    };
};
